export default "__VITE_ASSET__D32t_T8v__"